export * from './components';

// TODO: add global animations utility
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

function addAnimations() {
  let sections = document.querySelectorAll('.animate__slideInUp--contents');

  sections.forEach(element => {
    let items = element.querySelectorAll(':scope > *');

    let tl = gsap.timeline().from(items, { y: 100, opacity: 0, stagger: 0.2 }, 0);

    ScrollTrigger.create({
      trigger: element,
      start: 'top 90%',
      // toggleActions: 'play none none reverse',
      animation: tl,
    });
  });
}
window.addEventListener('DOMContentLoaded', addAnimations);

// Example animations by class toggle (not used)
// @ts-ignore
function addAnimationsByClass() {
  const targets = 'h1, h2, h3, h4, h5, p, li';
  const items = gsap.utils.toArray(document.querySelectorAll(targets));
  items.forEach((item: HTMLElement) => {
    item.classList.add('animated', 'preSlide');
    gsap.from(item, {
      scrollTrigger: {
        start: 'top bottom',
        end: 'bottom top',
        trigger: item,
        // markers: true,
        // toggleClass: 'slideIn',
        onEnter() {
          item.classList.add('slideIn');
        },
      },
    });
  });
}

function setNavHereStates(){
  if(window.location.pathname && window.location.pathname !== "" ){
    let links = document.querySelectorAll('.fls-nav a[href="'+ window.location.pathname +'"]');
    links.forEach ( (item) => {
        item.setAttribute('aria-current', 'page');
        let navItem = item.closest('.nav-item');
        if(navItem) {
            let navLink = navItem.querySelector('.nav-link');
             if(navLink) {
                navLink.setAttribute('aria-current', 'true');
             }
        }
    });
  }
}
window.addEventListener('DOMContentLoaded', setNavHereStates);

function setLoginButtonHandler(){
  Array.from(document.querySelectorAll('button.btn-provider-login, .footer--btn-login')).forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault();
      window.open('https://www.flshots.com/flshots/signin.csp');
    });
  });
}
window.addEventListener('DOMContentLoaded', setLoginButtonHandler);
